import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ENTERPRISE, tabIdToProductLevels } from './constants/routing/Tabs';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { useSelector } from 'react-redux';
import { isAppAuthSelector } from './selectors/AuthSelectors';
import MobileSuitePage from './components/mobile/suite-page/MobileSuitePage';
import SplashPage from './components/splash-page/SplashPage';
import ComparePage from './components/compare/ComparePage';
import Loadable from 'UIComponents/decorators/Loadable';
import CodeSplitEnvWrapper from './components/common/env/CodeSplitEnvWrapper'; // @ts-expect-error Not migrated to TS

import ConstantsTest from './components/tests/ConstantsTest';
import MobileFreeToolsPage from './components/mobile/MobileFreeToolsPage';
import MobileBundlePage from './components/mobile/MobileBundlePage';
import MobileProductPage from './components/mobile/MobileProductPage';
import Application from './containers/Application';
import ErrorPage from 'pricing-pages-ui/components/error-page/ErrorPage';

const ProductPageRoute = ({
  path,
  Component = MobileProductPage,
  productLine
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);

  if (isAppAuth) {
    return /*#__PURE__*/_jsx(Route, {
      path: path,
      render: () => /*#__PURE__*/_jsx(Component, {
        productLine: productLine
      })
    });
  }

  return /*#__PURE__*/_jsx(Route, {
    path: `${path}/:tab?`,
    render: ({
      match: {
        params: {
          tab
        }
      }
    }) => {
      if (!tab || !Object.keys(tabIdToProductLevels).includes(tab)) {
        getUsageTracker().setProperties({
          defaultedTab: ENTERPRISE
        });
        return /*#__PURE__*/_jsx(Redirect, {
          to: createToObject(`${path}/${ENTERPRISE}`)
        });
      }

      return /*#__PURE__*/_jsx(Component, {
        productLine: productLine
      });
    }
  });
};

const ContactsConfirmationPage = Loadable({
  loader: () => import(
  /* webpackChunkName: "contacts-confirmation" */
  'pricing-pages-ui/components/contacts-confirmation-page/ContactsConfirmationPage'),
  LoadingComponent: () => null
});
export default function MobileRoutes() {
  // TODO: Wrap with Public application component HOC
  const isAppAuth = useSelector(isAppAuthSelector);
  return /*#__PURE__*/_jsx(Application, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [isAppAuth && /*#__PURE__*/_jsx(Route, {
        path: "/:page/*",
        render: ({
          location,
          match: {
            params: {
              page
            }
          }
        }) => {
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              pathname: `/${page}`
            })
          });
        }
      }), /*#__PURE__*/_jsx(Route, {
        path: "/confirm-contacts",
        render: ({
          location: {
            state
          },
          history
        }) => {
          if (!state) {
            history.goBack();
            return null;
          }

          return /*#__PURE__*/_jsx(ContactsConfirmationPage, {});
        }
      }), /*#__PURE__*/_jsx(Route, {
        path: "/bundle",
        component: MobileBundlePage
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/suite",
        Component: MobileSuitePage
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/splash",
        Component: SplashPage
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/sales",
        productLine: SALES
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/service",
        productLine: SERVICE
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/cms",
        productLine: CMS
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/marketing",
        productLine: MARKETING
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/operations",
        productLine: OPERATIONS
      }), /*#__PURE__*/_jsx(Route, {
        path: "/crm",
        component: MobileFreeToolsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/compare",
        component: ComparePage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/legacy-starter-confirmation",
        children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          authedComponentLoader: () => import(
          /* webpackChunkName: "legacy-starter-sidegrade" */
          `pricing-pages-ui/components/legacy-starter-sidegrade-page/SidegradeWarningPage`),
          publicComponentLoader: () => import(
          /* webpackChunkName: "error-page" */
          `pricing-pages-ui/components/error-page/ErrorPage`)
        })
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/",
        exact: true,
        to: createToObject('/marketing')
      }), /*#__PURE__*/_jsx(Route, {
        path: "/_constants-test",
        children: /*#__PURE__*/_jsx(ConstantsTest, {})
      }), /*#__PURE__*/_jsx(Route, {
        component: ErrorPage
      })]
    })
  });
}